import { List } from "antd";
import { ListItemProps, ListProps } from "./type";

function AntList<T>(props: ListProps<T>) {
  return <List {...props} />;
}

function AntListItem(props: ListItemProps) {
  return <List.Item {...props} />;
}

const AntListMeta = List.Item.Meta;
export { AntListItem as Item, AntList as List, AntListMeta as ListMeta };
